<div class="animated fadeIn trafficDetail pt-2 md:pt-6">
    <div class="flex-container flex-billboard-container">
        @if(isDataSetLoaded$ | async) {
            <scorecard-billboard-element
                *ngFor="let item of items"
                [settings]="item.settings"
                [dataSets]="dataSets$ | async"
                [viewContext]="viewContext"
                class="bs-col-md-6 flex-billboard-card-50"
            />
        } @else {
            <scorecard-billboard-element *ngFor="let item of [0,1,2,3,4]"
                [dataSets]="undefined"
                [settings]="{ options: { entityName: 'foo' } }"
                class="bs-col-md-6 flex-billboard-card-50" 
            />
        }
    </div>
</div>
